export const environment = {
  production: true,
  authServiceUrl: 'https://id.irembohub.com',
  authRealm: 'irembo',
  authClientId: 'service-management-portal',
  authSuccessRedirectUrl: 'https://builder.irembohub.com',
  apiGatewayBaseUrl: 'https://builder.api.irembohub.com',
  enableKeycloakMockService: false,
  citizenApiGatewayBaseUrl: 'https://api.iremboinc.com',
  DEFAULT_LOCALE: 'en-US',
  translationSourceUrl: 'https://builder.api.irembohub.com',
  mockBaseUrl: 'https://builder.api.irembohub.com',
  testPortalUrls: {
    citizen: 'https://sandbox.irembohub.com',
    iremboPlus: 'https://sandbox.irembohub.com',
    rdbOsc: 'https://sandbox.irembohub.com',
  },
};
